import CssBaseline from '@material-ui/core/CssBaseline';
import {createMuiTheme} from '@material-ui/core/styles';
import {ThemeProvider} from '@material-ui/styles';
import React from 'react';

export const theme = createMuiTheme({
  overrides: {
    MuiSnackbar: {
      root: {
        backgroundColor: '#0033A0',
        borderRadius: '4px',
      },
    },
    MuiSnackbarContent: {
      root: {
        backgroundColor: '#0033A0',
      },
    },
    MuiButton: {
      label: {
        fontSize: 12,
      },
    },
    MuiStepIcon: {
      active: {
        color: '#FF9E16',
      },
    },
    MuiMenuItem: {
      root: {
        fontSize: 14,
      },
    },
  },
  palette: {
    primary: {
      main: '#0033A0',
    },
    secondary: {
      contrastText: '#0033A0',
      main: '#FF9E16',
    },
    type: 'light',
  },
  typography: {
    fontFamily: '"AllstateObjektiv", Arial',
    body1: {
      fontSize: 16,
    },
    body2: {
      fontSize: 16,
    },
  },
});

const WithTheme = <TProps extends {}>(Component: React.ComponentClass<TProps> | React.FunctionComponent<TProps>) => (
  props: TProps
) => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Component {...props} />
  </ThemeProvider>
);

export default WithTheme;
